import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { UserProvider, useUser } from './contexts/UserContext';
import Navbar from './components/Navbar';
import Dashboard from './pages/Dashboard';
import OrganizationalUnits from './pages/OrganizationalUnits';
import AccessRequest from './pages/AccessRequest';
import RoleDelegation from './pages/RoleDelegation';
import RoleVerificationPage from './pages/RoleVerificationPage';
import AdminAnalytics from './pages/AdminAnalytics';
import CustomerAdmins from './pages/CustomerAdmins';
import Login from './pages/Login';
import Loading from './components/Loading';
import AccessDenied from './components/AccessDenied';

function App() {
  return (
    <UserProvider>
      <AppContent />
    </UserProvider>
  );
}

function AppContent() {
  const { user, loading, domainAccess, isAuthorized, isSuperAdmin } = useUser();

  if (loading) {
    return <Loading />;
  }

  if (!user) {
    return <Login />;
  }

  // Check if user is authorized to access the application
  if (!isAuthorized()) {
    return <AccessDenied user={user} reason={domainAccess.reason} />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar user={user} />
      <main className="container mx-auto px-4 py-8">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/organisational-units" element={<OrganizationalUnits />} />
          <Route path="/access-request" element={<AccessRequest />} />
          <Route path="/role-delegation" element={<RoleDelegation />} />
          <Route path="/role-verification" element={<RoleVerificationPage />} />
          {isSuperAdmin() && <Route path="/admin/analytics" element={<AdminAnalytics />} />}
          {isSuperAdmin() && <Route path="/admin/customer-admins" element={<CustomerAdmins />} />}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export default App; 